import { useEffect, useState } from "react";
import { Link, useLocation } from "react-router-dom";
import SearchBox from "../SearchBox/SearchBox";
import { useGeneralStyle } from "../../context/GeneralStyleContext";
import styles from "./NavBar.module.css";
import useIsMobile from "../../utils/isMobile";

import { motion, AnimatePresence } from "framer-motion";
import { button } from "framer-motion/client";
import { FontAwesomeIcon as Ficon } from "@fortawesome/react-fontawesome";
import {
  faShoppingCart,
  faHome,
  faLocationDot,
  faSearch,
  faUser,
  faGlobe,
} from "@fortawesome/free-solid-svg-icons";
import { faAndroid } from "@fortawesome/free-brands-svg-icons/faAndroid";
import { faWebflow } from "@fortawesome/free-brands-svg-icons";

const labelVariants = {
  initial: { opacity: 0, fontSize: "0.01rem", margin: "00rem" },
  animate: {
    opacity: 1,
    fontSize: "1rem",
    margin: "0.5rem",
    transition: { duration: 0.2, ease: "easeInOut", delay: 0.2 },
  },
  exit: { opacity: 0, transition: { duration: 0.2, ease: "easeInOut" } },
};

const NavBar = ({ handleSearch, searchState }) => {
  const location = useLocation();
  const { navExpand, setNavExpand } = useGeneralStyle();
  const isMobile = useIsMobile();
  const [raahyabOpen, setRaahyabOpen] = useState(false);

  useEffect(() => {
    if (location.pathname == "/") {
      const handleScroll = () =>
        window.scrollY >= 100 ? setNavExpand(false) : setNavExpand(true);
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    } else setNavExpand(false);
  }, [location]);

  const navlist = [
    {
      id: 0,
      name: "Profile",
      icon: faUser,
      link: "/Profile",
      title: "حساب کاربری",
    },
    {
      id: 1,
      name: "Products",
      icon: faShoppingCart,
      link: "/Products",
      title: "صفحه محصولات",
    },
    { id: 2, name: "Home", icon: faHome, link: "", title: "صفحه نخست" },
    { id: 3, name: "Search", icon: faSearch, onclick: "", title: "جستجو؟" },
    {
      id: 4,
      name: "Raahyab",
      icon: faLocationDot,
      link: "http://www.raahyab.com",
      title: "نرم‌افزار راه‌یاب",
    },
  ];

  const handleRaahyabClick = (ev) => {
    // اجازه به Ctrl/Cmd/Middle-click برای باز شدن در تب جدید
    if (ev.metaKey || ev.ctrlKey || ev.button === 1) return;
    ev.preventDefault(); // نگذار ناوبری انجام شود
    setRaahyabOpen((v) => !v); // نشان/پنهان کردن دکمه‌ها
  };

  useEffect(() => {
    const navLinks = Array.from(
      document.querySelectorAll(`.${styles.navLink}`)
    );
    navLinks.forEach((e) => {
      const href = e.getAttribute("href");

      location.pathname == "/" && href == "/"
        ? e.classList.add(styles.navActive)
        : location.pathname.startsWith(href) &&
          location.pathname != "/" &&
          href != "/"
        ? e.classList.add(styles.navActive)
        : location.pathname.startsWith("/Product") && href == "/Products"
        ? e.classList.add(styles.navActive)
        : e.classList.remove(styles.navActive);
    });
  }, [location]);

  return (
    <div className={`nav_cont ${styles.navCont}`}>
      {!isMobile ? (
        <motion.nav
          className={`nav ${styles.nav}`}
          style={{ position: "relative" }} // برای پنل جستجو
          initial={{ width: "3rem" }}
          animate={{ width: navExpand ? "15rem" : "4rem" }}
          transition={{ duration: 0.3, ease: "easeInOut", delay: 0.1 }}>
          <ul className={styles.navUl}>
            {navlist.map((e) => {
              const isSearch = e.name === "Search";
              const isRaahyab = e.name === "Raahyab";

              return (
                <li className={`nav-li ${styles.navLi}`} key={e.id}>
                  {/* آیتم جستجو */}
                  {isSearch ? (
                    <>
                      <button
                        type="button"
                        onClick={handleSearch}
                        className={styles.navLink}
                        aria-expanded={Boolean(searchState)}
                        aria-controls="search-panel">
                        <Ficon className={styles.icon} icon={e.icon} />
                        <AnimatePresence>
                          {navExpand && (
                            <motion.span
                              className={styles.navLiTitle}
                              variants={labelVariants}
                              initial="initial"
                              animate="animate"
                              exit="exit">
                              {e.title}
                            </motion.span>
                          )}
                        </AnimatePresence>
                      </button>

                      <AnimatePresence>
                        {searchState && (
                          <motion.div
                            id="search-panel"
                            initial={{ opacity: 0, x: 50 }}
                            animate={{
                              opacity: 1,
                              x: navExpand ? -240 : -64, // معادل rem به px، تنظیم کن
                            }}
                            exit={{ opacity: 0, x: 50 }}
                            transition={{ duration: 0.1, ease: "easeInOut" }}
                            style={{
                              width: "30vw",
                              height: "100%",
                              position: "absolute",
                              top: 0,
                              right: 0,
                              zIndex: 5,
                            }}>
                            <SearchBox />
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </>
                  ) : isRaahyab ? (
                    // آیتم Raahyab: لینک بیرونی + دکمه‌های جدا
                    <>
                      <a
                        className={styles.navLink}
                        href={e.link}
                        target="_blank"
                        rel="noopener noreferrer"
                        aria-label={e.title || e.name}
                        aria-expanded={raahyabOpen}
                        onClick={handleRaahyabClick}>
                        <Ficon className={styles.icon} icon={e.icon} />
                        <AnimatePresence>
                          {navExpand && (
                            <motion.span
                              className={styles.navLiTitle}
                              variants={labelVariants}
                              initial="initial"
                              animate="animate"
                              exit="exit">
                              {e.title}
                            </motion.span>
                          )}
                        </AnimatePresence>
                      </a>

                      <AnimatePresence>
                        {raahyabOpen && (
                          <motion.div
                            className={styles.raahyabBtns}
                            initial={{ opacity: 0, x: 60 }}
                            animate={{ opacity: 1, x: 0 }}
                            exit={{ opacity: 0, x: 60 }}
                            transition={{ duration: 0.15, ease: "easeInOut" }}>
                            <a
                              href="/Files/RaahyabManager-v1.0.0.apk"
                              target="_blank"
                              style={{ backgroundColor: "#00ad00" }}>
                              <Ficon icon={faAndroid} />
                            </a>
                            <a
                              href="http://www.raahyab.com"
                              target="_blank"
                              style={{ backgroundColor: "#202020" }}>
                              <Ficon icon={faGlobe} />
                            </a>
                          </motion.div>
                        )}
                      </AnimatePresence>
                    </>
                  ) : (
                    // سایر آیتم‌ها: مسیر داخلی با Link
                    <Link
                      className={styles.navLink}
                      to={e.link}
                      aria-label={e.title || e.name}>
                      <Ficon className={styles.icon} icon={e.icon} />
                      <AnimatePresence>
                        {navExpand && (
                          <motion.span
                            className={styles.navLiTitle}
                            variants={labelVariants}
                            initial="initial"
                            animate="animate"
                            exit="exit">
                            {e.title}
                          </motion.span>
                        )}
                      </AnimatePresence>
                    </Link>
                  )}
                </li>
              );
            })}
          </ul>
        </motion.nav>
      ) : (
        <ul className={styles.navUl}>
          {navlist.map((e) => {
            const isSearch = e.name === "Search";
            const isRaahyab = e.name === "Raahyab";
            return (
              <li className={`nav-li ${styles.navLi}`} key={e.id}>
                {isSearch ? (
                  <>
                    <button
                      type="button"
                      onClick={handleSearch}
                      className={styles.navLink}
                      aria-expanded={Boolean(searchState)}
                      aria-controls="m-search-panel">
                      <Ficon className={styles.icon} icon={e.icon} />
                    </button>
                  </>
                ) : isRaahyab ? (
                  <>
                    <a
                      className={styles.navLink}
                      href={e.link}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={e.title || e.name}
                      aria-expanded={raahyabOpen}
                      onClick={(ev) => {
                        // اجازه به Ctrl/Cmd/Middle در موبایل معنایی ندارد؛ اما برای یکدستی:
                        if (ev.metaKey || ev.ctrlKey || ev.button === 1) return;
                        ev.preventDefault();
                        setRaahyabOpen((v) => !v);
                      }}>
                      <Ficon className={styles.icon} icon={e.icon} />
                    </a>

                    <AnimatePresence>
                      {raahyabOpen && (
                        <motion.div
                          className={styles.raahyabBtns}
                          initial={{ opacity: 0, y: 6 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: 6 }}
                          transition={{ duration: 0.2, ease: "easeInOut" }}>
                          <a
                            href="/Files/RaahyabManager-v1.0.0.apk"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="دانلود نسخه اندروید"
                            className={styles.raahyabBtn}
                            style={{ backgroundColor: "#00ad00" }}>
                            <Ficon icon={faAndroid} />
                          </a>
                          <a
                            href="http://www.raahyab.com"
                            target="_blank"
                            rel="noopener noreferrer"
                            aria-label="وب‌سایت راهیاب"
                            className={styles.raahyabBtn}
                            style={{ backgroundColor: "#202020" }}>
                            <Ficon icon={faGlobe} />
                          </a>
                        </motion.div>
                      )}
                    </AnimatePresence>
                  </>
                ) : (
                  <Link
                    className={styles.navLink}
                    to={e.link}
                    aria-label={e.title || e.name}>
                    <Ficon className={styles.icon} icon={e.icon} />
                  </Link>
                )}
              </li>
            );
          })}
          <AnimatePresence>
            {searchState && (
              <motion.div
                id="search-panel"
                initial={{ opacity: 0, y: -6 }}
                animate={{ opacity: 1, y: 0, zIndex: "1" }}
                exit={{ opacity: 0, y: -6 }}
                transition={{ duration: 0.2, ease: "easeInOut" }}
                className={styles.mobileSearchSheet}
                role="dialog"
                aria-modal="true">
                <div className={styles.mobileSearchHeader}></div>
                <SearchBox />
              </motion.div>
            )}
          </AnimatePresence>
        </ul>
      )}
    </div>
  );
};

export default NavBar;
